<template>
  <div id="container" class="cart_st">
    <!-- 판매자 등록 완료 START -->
    <div class="section full">
      <div class="inner">
        <div class="btn_wrap" data-detail="shortcuts">
          <router-link :to="{ name: 'orders' }" class="box_btn line">
            <span class="c_icon ico_shortcuts_arrow"></span>
            <span class="an_t">{{
              $t('views.member.seller.sellerstep3.4908')
            }}</span>
          </router-link>
        </div>
        <div class="box_wrap" data-detail="done_detail">
          <div class="cart_progress">
            <div class="progress_box">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep3.338')
                }}</span
                >{{ $t('views.member.seller.sellerstep3.4548') }}
              </p>
            </div>
            <div class="c_icon ico_progress_arrow"></div>
            <div class="progress_box">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep3.9485')
                }}</span
                >{{ $t('views.member.seller.sellerstep3.8307') }}
              </p>
            </div>
            <div class="c_icon ico_progress_arrow"></div>
            <div class="progress_box active">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep3.829')
                }}</span
                >{{ $t('views.member.seller.sellerstep3.3563') }}
              </p>
            </div>
          </div>
          <div class="box">
            <div class="box_title">
              <h2 class="done_tit">
                {{ $t('views.member.seller.sellerstep3.575') }}
              </h2>
            </div>

            <ul class="done_images" data-detail="join_done">
              <!-- <li><img src="@/assets/images/svg/cart_done.svg" alt="" /></li> -->
              <li class="an_a">
                <!-- <img
                  src="@/assets/images/svg/cart_done_vis.svg"
                  alt="지금 바로 이앨리스를 이용해보세요!"
                /> -->
                <span class="an_t">{{
                  $t('views.member.seller.sellerstep3.1399')
                }}</span>
              </li>
            </ul>

            <div class="btn_wrap">
              <router-link :to="{ name: 'selfbook_sales' }" class="box_btn">
                <span class="an_t">{{
                  $t('views.member.seller.sellerstep3.7810')
                }}</span>
              </router-link>
              <router-link :to="{ name: 'store' }" class="box_btn dull">
                <span class="an_t">{{
                  $t('views.member.seller.sellerstep3.9960')
                }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 판매자 등록 완료 END -->
  </div>
</template>

<script>
export default {
  name: 'SellerStep3'
}
</script>

<style lang="scss" scoped></style>
